<template>
  <v-container fluid>
    <PageTitle style="margin: 15px 0px !important" :title="mainTitle" />
    <PageHeaderWithButton hideActiveNo :hideTopSection="true">
      <template #action>
        <span></span>
      </template>
      <ExBreadcrumbs
        v-if="!hideBreadCrumMenu"
        class="px-3 pt-4 pb-6"
        :breadcrumbsList="breadcrumItems"
      />
      <ActivateResponsibilityConfirmationModal
        :dialog="showActivateResponsibility"
        @close="showActivateResponsibility = false"
        @skip="skipActivateResponsibility"
        @activate="activateAttachedResponsibilities"
        :role="currentRole?.data?.name"
        :draftResponsibilityCount="roleHasDraftResponsibility"
        :skipButtonLoader="skipButtonLoader"
        :activateButtonLoader="activateButtonLoader"
      />
      <ReadinessCatalogs
        ref="readinessCatalogs"
        :dataSource="sanitizeDataSourceforReadinessCatalogs"
        :allDataSource="sanitizeDataSourceforReadinessCatalogs"
        @onRowOperation="handleReadinessOperations($event)"
        @onAddRole="actions.showAddRoleDialog = true"
        @onAddResponsibility="actions.showAddResponsibilityDialog = true"
        @onRequest="onRequestPagination($event)"
        @changeView="onChangeView($event)"
        @appliedFilter="appliedFilter($event)"
        @appliedFilterFromAPI="appliedFilterFromAPI($event)"
        @appliedFilterRemoved="appliedFilterRemoved()"
        @searchTextData="searchTextData($event)"
        @onSort="handleSort"
        :pagination="currentPaginationModel"
        :menu-items="menuItemsProp"
        @detach="detachOrgObject($event)"
        @openChatterDrawer="handleOpenChatterDrawer($event)"
        :loader="detachLoader"
        :chatterData="chatterData"
        :totalChatterData="totalChatterData"
        @sequenceReorder="reOrderData($event)"
        @requestMoreCheckpointsChatter="handleLoadMoreChatterData()"
        :defaultSearch="defaultSearch"
        :initial-tab="initialTab"
      />
    </PageHeaderWithButton>
    <AddRoleDialog
      v-model="actions.showAddRoleDialog"
      @onSave="saveNewRole($event)"
      @clearError="clearRoleError"
      :errorMessage="roleErrorMessage"
    />
    <ActivateRole
      v-model="actions.activateRoleDialog"
      @onSave="activateRole"
      :role="currentRole"
    />
    <RenameRole
      v-model="actions.showRenameRoleDialog"
      @onSave="renameRole"
      :role="currentRole?.data?.name || ''"
    />
    <AttachedRole
      v-model="actions.attachedRoleDialog"
      @onSave="attachRoleToResponsibility()"
      :items="items"
      @item-selected="handleItemSelected"
      @add-item-selected="addHandleItemSelected"
      :existingNamesList="existingResponsibilitiesNames"
      :parentName="currentRole?.data?.name || ''"
      :openDefault="openDefault"
      @input="closeDialog"
      :type="
        showAttachResponsibilitiesPicker
          ? 'attach_responsibility_role_new_picker'
          : 'attach_responsibility_role'
      "
      @load-more="loadMoreResponsibilities"
      @search="searchResponsibilities"
      :hasMoreData="hasMoreData"
      :isLoadingMore="isLoadingMore"
      :isAssigning="isAssigningObject"
    />
    <DeleteRole
      v-model="actions.deleteRoleDialog"
      @onDelete="deleteRole($event)"
      :role="currentRole || ''"
    />
    <AddResponsibility
      v-model="actions.showAddResponsibilityDialog"
      @onSave="createResponsibility($event)"
      @clearError="clearResponsibilityError"
      :errorMessage="responsibilityErrorMessage"
    />
    <RenameResponsibility
      v-model="actions.showRenameResponsibilityDialog"
      @onSave="renameResponsibility($event)"
      :responsibility="currentResponsibility?.data?.name || ''"
    />
    <DeleteResponsibility
      v-model="actions.deleteResponsibilityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onDelete="deleteResponsibility"
    />
    <ActivateResponsibility
      v-model="actions.showActivateResponsiblityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="activateResponsibility"
    />
    <RetireResponsibility
      v-model="actions.showRetireResponsibilityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="retireResponsibility"
    />
    <RetiredRole
      v-model="actions.retiredRoleDialog"
      @onSave="retiredRole"
      :role="currentRole"
    />
    <DeActivateRole
      v-model="actions.deActivateRoleDialog"
      @onSave="deActivateRole"
      :role="currentRole"
    />
    <ReActivateRole
      v-model="actions.reActivateRoleDialog"
      @onSave="reActivateRole"
      :role="currentRole"
    />
    <DeActivateResponsibility
      v-model="actions.showDeActivateResponsiblityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="deActivateResponsibility"
    />
    <ReActivateResponsibility
      v-model="actions.showReActivateResponsiblityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="reActivateResponsibility"
    />
    <DetachDialog
      v-model="actions.showDetachDialog"
      :position="parentName || ''"
      :role="currentItem || {}"
      @onAction="detachAction"
    />
    <AttachedResponsibilityToRole
      v-model="actions.showAttachRoleDialog"
      OrgObjectType="Responsibility to Role"
      @onSave="attachResponsibilityToRole"
      :type="
        showAttachResponsibilitiesPicker
          ? 'respToRole_new_picker'
          : 'respToRole'
      "
      :items="attachableRoles"
      @item-selected="handleItemSelected"
      @add-item-selected="addNewRole"
      :parent-name="currentResponsibility?.data?.name || ''"
      :hasMoreData="hasMoreData"
      :isLoadingMore="isLoadingMore"
      @load-more="loadMoreRoles"
      @search="searchRoles"
      :isAssigning="isAssigningObject"
    />
    <ArchivePopUp
      :action="archiveAction"
      :type="currentObj"
      :show="actions.showArchiveDialog"
      :curretObj="currentObj == 'role' ? currentRole : currentResponsibility"
      @onClose="actions.showArchiveDialog = false"
      @onArchive="onArchiveCatalogs"
    ></ArchivePopUp>
  </v-container>
</template>
<script>
import ExBreadcrumbs from "@components/breadcrumbs/ExBreadcrumbs.vue";
import ReadinessCatalogs from "@components/RolesCatalog/ReadinessCatalogs.vue";
import responsibilityMixin from "@components/views/mixins/responsibilityMixin";
import roleMixin from "@components/views/mixins/roleMixin";
import PageHeaderWithButton from "@components/common/PageHeaderWithButton.vue";
import PageTitle from "@components/common/PageTitle.vue";
import ArchivePopUp from "@components/common/ArchivePopUp.vue";
import { mapState } from "vuex";
import { useSidebarCountStore } from "@/store/pinia/sidebarCount";
import ActivateResponsibilityConfirmationModal from "@components/ActivateResponsibilityConfirmationModal/ActivateResponsibilityConfirmationModal.vue";
import AttachedResponsibilityToRole from "@components/RolesCatalog/AttachedResponsibilityToRole.vue";
import AddRoleDialog from "@components/RolesCatalog/AddRoleDialog/AddRoleDialog.vue";

export default {
  name: "RolesCatalogView",
  components: {
    ReadinessCatalogs,
    ExBreadcrumbs,
    PageTitle,
    PageHeaderWithButton,
    ArchivePopUp,
    ActivateResponsibilityConfirmationModal,
    AttachedResponsibilityToRole,
    AddRoleDialog,
  },
  mixins: [responsibilityMixin, roleMixin],
  data() {
    return {
      sidebarCountStore: useSidebarCountStore(),
      // originalDataSource: [],
      dataSource: [],
      dataSourceRoles: [],
      dataSourceResponsibilities: [],
      dataSourceKnowledge: [],
      accountId: null,
      parentName: null,
      currentItem: null,
      currentObj: null,
      archiveAction: null,
      isAssigningObject: false,
      initialTab: 0,
      actions: {
        showAddRoleDialog: false,
        showAddResponsibilityDialog: false,
        activateRoleDialog: false,
        attachedRoleDialog: false,
        retiredRoleDialog: false,
        deleteRoleDialog: false,
        showRenameRoleDialog: false,
        showRenameResponsibilityDialog: false,
        deleteResponsibilityDialog: false,
        showActivateResponsiblityDialog: false,
        showRetireResponsibilityDialog: false,
        deActivateRoleDialog: false,
        reActivateRoleDialog: false,
        showDeActivateResponsiblityDialog: false,
        showReActivateResponsiblityDialog: false,
        showDetachDialog: false,
        showAttachRoleDialog: false,
        showArchiveDialog: false,
      },
      paginationModel: {
        page: 1,
        total: 0,
        perPage: 10,
      },
      appliedFilters: [],
      appliedFiltersFromAPI: [],
      currentRole: null,
      currentResponsibility: null,
      items: [],
      attachableRoles: [],
      attachmentId: null,
      currentResponse: null,
      modalHeaderState: undefined,
      dataResponsibilitiesBadge: [],
      employeeData: [],
      badgeFrameItems: [],
      menuItems: [
        { title: "Description", count: 0 },
        { title: "Checklist", count: 0 },
        { title: "Badge Holders", count: 0 },
        { title: "Assignments", count: 0 },
        { title: "Defaults", count: 0 },
        { title: "Chatter", count: 0 },
      ],
      badgeData: null,
      breadcrumItems: [],
      existingResponsibilitiesNames: [],
      searchItems: [],
      hideBreadCrumMenu: false,
      showActivateResponsibility: false,
      roleHasDraftResponsibility: 0,
      resolveActivateDialog: null,
      chatterData: [],
      totalChatterData: 0,
      currentChatterItem: null, // Store current item for load more functionality
      isDashboardFeatureEnabled: false,
      openDefault: false,
      skipButtonLoader: false,
      activateButtonLoader: false,
      mainTitle: "Readiness Catalogs",
      defaultSearch: "",

      // Pagination state for responsibilities picker
      currentPage: 1,
      hasMoreData: false,
      isLoadingMore: false,
      currentRoleId: null,
      currentResponsibilityId: null,
      currentSearchTerm: "",
      createNewRole: false,
      createNewResponsibility: false,
      currentSearchTermForCatalogs: "",
      currentOrdering: "name",
      responsibilityErrorMessage: "",
      roleErrorMessage: "",
    };
  },
  async created() {},
  async mounted() {
    this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
    await this.$watchFlag("catalogs.dashboard.enabled");
    await this.$watchFlag("test-title-with-context", "Readiness Catalog");
    await this.$getFlag("catalogs.dashboard.enabled");
    this.isDashboardFeatureEnabled = await this.$getFlag(
      "catalogs.dashboard.enabled"
    );
    this.mainTitle = await this.$getFlag("test-title-with-context");
    // If mainTitle is false, fallback to "Readiness Catalog"
    if (this.mainTitle === false) {
      this.mainTitle = "Readiness Catalog";
    }
    this.initializeBreadcrumbs();
    // Handle route redirection when dashboard is disabled
    if (
      !this.isDashboardFeatureEnabled &&
      this.$route.name === "ReadinessCatalogs"
    ) {
      await this.$router.push("/readiness/catalogs/roles");
      return;
    }

    // Handle initial route to set correct tab
    this.setInitialTab();
    this.$loader.show();

    // Load saved filters before making initial API call
    const currentTab = this.$route?.params?.type || "roles";
    let storeFilterKey = "";
    if (currentTab === "roles") {
      storeFilterKey = "readinessrole";
    } else if (currentTab === "responsibilities") {
      storeFilterKey = "readinessresponsibility";
    }
    await this.$store.dispatch("filterStore/loadFilters", storeFilterKey);
    const savedFilters = this.$store.state.filterStore.filters;

    if (savedFilters && savedFilters.length > 0) {
      this.appliedFiltersFromAPI = savedFilters;
    }

    // Always make initial API call with saved filters if they exist
    await this.loadDataSourceForReadinessCatalogs({
      limit: 10,
      offset: 0,
      search: "",
      filters: savedFilters || [],
      page: 1,
      ordering:
        this.$route?.params?.type === "responsibilities"
          ? this.$store.state.readinessCatalogsStore.responsibilitiesOrdering
          : this.$store.state.readinessCatalogsStore.ordering,
    });
    setTimeout(() => {
      this.$loader.hide();
    }, 500);
  },
  watch: {
    sanitizeDataSource(newVal) {
      if (newVal) {
        if (
          this.$route?.params?.type === "responsibilities" ||
          this.$route?.params?.type === "roles" ||
          this.$route?.name === "OrgPosition"
        ) {
          return;
        } else {
          this.paginationModel.total = newVal.filter(
            (el) => el.parentId == -1
          ).length;
        }
      }
    },
  },
  methods: {
    async handleOpenChatterDrawer(typeData) {
      // Store the current item for load more functionality
      this.currentChatterItem = typeData;
      // Call the mixin method with isLoadMore = false (initial load)
      await this.openChatterDrawer(typeData, false);
    },
    async handleLoadMoreChatterData() {
      // Use the stored current item to load more data
      if (this.currentChatterItem) {
        await this.openChatterDrawer(this.currentChatterItem, true);
      }
    },
    setInitialTab() {
      const currentPath = this.$route.path;

      if (this.isDashboardFeatureEnabled) {
        // Dashboard mode: 0=dashboard, 1=roles, 2=responsibilities
        if (currentPath.includes("/roles")) {
          this.initialTab = 1;
        } else if (currentPath.includes("/responsibilities")) {
          this.initialTab = 2;
        } else {
          // Default to dashboard
          this.initialTab = 0;
        }
      } else {
        // Non-dashboard mode: 0=roles, 1=responsibilities
        if (currentPath.includes("/responsibilities")) {
          this.initialTab = 1;
        } else {
          // Default to roles
          this.initialTab = 0;
        }
      }
    },

    initializeBreadcrumbs() {
      this.breadcrumItems = [
        {
          text: "Readiness Catalogs",
          disabled: false,
          href: "/readiness/catalogs",
        },
      ];

      if (this.isDashboardFeatureEnabled) {
        // For dashboard version, determine initial breadcrumb based on current route
        const currentPath = this.$route.path;
        if (currentPath.includes("/responsibilities")) {
          this.breadcrumItems.push({
            text: "Responsibilities",
            disabled: false,
            href: "/readiness/catalogs/responsibilities",
          });
        } else if (currentPath.includes("/roles")) {
          this.breadcrumItems.push({
            text: "Roles",
            disabled: false,
            href: "/readiness/catalogs/roles",
          });
        } else {
          // Default to Dashboard for base catalog path
          this.breadcrumItems.push({
            text: "Dashboard",
            disabled: false,
            href: "/readiness/catalogs",
          });
        }
      } else {
        // For the original version, determine initial breadcrumb based on current route
        const currentPath = this.$route.path;
        if (currentPath.includes("/responsibilities")) {
          this.breadcrumItems.push({
            text: "Responsibilities",
            disabled: true,
            href: "/readiness/catalogs/responsibilities",
          });
        } else {
          // Default to Roles for /roles path or base catalog path
          this.breadcrumItems.push({
            text: "Roles",
            disabled: true,
            href: "/readiness/catalogs/roles",
          });
        }
      }
    },
    detachOrgObject(data) {
      this.detachItems(data, () => {
        if (data.callBackFunc && typeof data.callBackFunc === "function") {
          data.callBackFunc();
        }
      });
    },
    async appliedFilterFromAPI(data) {
      this.appliedFiltersFromAPI = data;
      try {
        this.$loader.show();
        // Reload data with the new filters
        await this.loadDataSourceForReadinessCatalogs({
          limit: 10,
          offset: 0,
          search: this.searchItems?.name,
          filters: data,
          page: 1,
          ordering:
            this.$route?.params?.type === "responsibilities"
              ? this.$store.state.readinessCatalogsStore
                  .responsibilitiesOrdering
              : this.$store.state.readinessCatalogsStore.ordering,
        });
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      } catch (error) {
        console.error("Search error:", error);
      }
    },
    appliedFilter(data) {
      if (this.$route?.params?.type === "roles") {
        return;
      }
      this.appliedFilters = data;
      if (data.length > 0) {
        if (data.includes("Show")) {
          this.dataSource = this.originalDataSource;
        } else if (data.includes("Do not Show")) {
          this.dataSource = this.originalDataSource.filter(
            (item) => item.archived === false
          );
        }
        const parentData = this.originalDataSource.filter(
          (item) => data.includes(item.status) && item.parentId === -1
        );
        const parentIds = parentData.map((parent) => parent.id);
        const childItems = this.originalDataSource.filter((item) =>
          parentIds.includes(item.parentId)
        );
        this.dataSource = [...parentData, ...childItems];
        const totalCount = this.dataSource.filter((el) => el.parentId == -1);
        this.paginationModel.total = totalCount.length;
        this.paginationModel.page = 1;
      } else {
        this.dataSource = this.originalDataSource;
        const totalCount = this.dataSource.filter((el) => el.parentId == -1);
        this.paginationModel.total = totalCount.length;
      }
    },
    async appliedFilterRemoved() {
      try {
        this.$loader.show();
        this.appliedFiltersFromAPI = [];
        this.appliedFilters = [];
        this.searchItems = [];
        this.defaultSearch = "";
        this.createNewRole = false;
        this.createNewResponsibility = false;
        await this.loadDataSourceForReadinessCatalogs({
          limit: 10,
          offset: 0,
          search: "",
          filters: [],
          page: 1,
          ordering:
            this.$route?.params?.type === "responsibilities"
              ? this.$store.state.readinessCatalogsStore
                  .responsibilitiesOrdering
              : this.$store.state.readinessCatalogsStore.ordering,
        });
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      } catch (error) {
        console.error("Search error:", error);
      }
    },
    async searchTextData(data) {
      if (
        this.$route?.params?.type === "responsibilities" ||
        this.$route?.params?.type === "roles"
      ) {
        this.defaultSearch = "";
        this.createNewRole = false;
        this.createNewResponsibility = false;
        this.searchItems = data;
        this.currentSearchTermForCatalogs = data.name;
        try {
          this.$loader.show();
          await this.loadDataSourceForReadinessCatalogs({
            limit: 10,
            offset: 0,
            search: data.name,
            filters: this.appliedFiltersFromAPI || [],
            ordering:
              this.$route?.params?.type === "responsibilities"
                ? this.$store.state.readinessCatalogsStore
                    .responsibilitiesOrdering
                : this.$store.state.readinessCatalogsStore.ordering,
          });
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
        } catch (error) {
          console.error("Search error:", error);
        }
      } else {
        this.searchItems = this.originalDataSource;
      }
    },
    async onChangeView(tab) {
      // Update initialTab to keep it in sync with current tab selection
      this.initialTab = tab;

      if (this.isDashboardFeatureEnabled) {
        if (tab == 0) {
          // Dashboard tab
          const roleIndex = this.breadcrumItems.findIndex(
            (el) => el.text == "Roles"
          );
          const responsibilityIndex = this.breadcrumItems.findIndex(
            (el) => el.text == "Responsibilities"
          );

          if (roleIndex > -1) {
            this.breadcrumItems.splice(roleIndex, 1, {
              text: "Dashboard",
              disabled: false,
              href: "/readiness/catalogs",
            });
          } else if (responsibilityIndex > -1) {
            this.breadcrumItems.splice(responsibilityIndex, 1, {
              text: "Dashboard",
              disabled: false,
              href: "/readiness/catalogs",
            });
          }
          // Always push router change
          if (this.$route.path != "/readiness/catalogs") {
            await this.$router.push("/readiness/catalogs");
          }
        } else if (tab == 1) {
          // Roles tab
          const dashboardIndex = this.breadcrumItems.findIndex(
            (el) => el.text == "Dashboard"
          );
          const responsibilityIndex = this.breadcrumItems.findIndex(
            (el) => el.text == "Responsibilities"
          );

          if (dashboardIndex > -1) {
            this.breadcrumItems.splice(dashboardIndex, 1, {
              text: "Roles",
              disabled: false,
              href: "/readiness/catalogs/roles",
            });
          } else if (responsibilityIndex > -1) {
            this.breadcrumItems.splice(responsibilityIndex, 1, {
              text: "Roles",
              disabled: false,
              href: "/readiness/catalogs/roles",
            });
          }

          // Always push router change
          if (this.$route.path != "/readiness/catalogs/roles") {
            await this.$router.push("/readiness/catalogs/roles");
          }
        } else if (tab == 2) {
          // Responsibilities tab
          const dashboardIndex = this.breadcrumItems.findIndex(
            (el) => el.text == "Dashboard"
          );
          const roleIndex = this.breadcrumItems.findIndex(
            (el) => el.text == "Roles"
          );

          if (dashboardIndex > -1) {
            this.breadcrumItems.splice(dashboardIndex, 1, {
              text: "Responsibilities",
              disabled: false,
              href: "/readiness/catalogs/responsibilities",
            });
          } else if (roleIndex > -1) {
            this.breadcrumItems.splice(roleIndex, 1, {
              text: "Responsibilities",
              disabled: false,
              href: "/readiness/catalogs/responsibilities",
            });
          }

          // Always push router change
          if (this.$route.path != "/readiness/catalogs/responsibilities") {
            await this.$router.push("/readiness/catalogs/responsibilities");
          }
        }
      } else {
        if (tab == 0) {
          // Roles tab (non-dashboard mode)
          if (!this.breadcrumItems.some((el) => el.text == "Roles")) {
            const existingItemIndex = this.breadcrumItems.findIndex(
              (el) => el.text == "Responsibilities"
            );
            if (existingItemIndex > -1) {
              this.breadcrumItems.splice(existingItemIndex, 1);
            }
            this.breadcrumItems.push({
              text: "Roles",
              disabled: false,
              href: "/readiness/catalogs/roles",
            });
          }

          // Always push router change
          if (this.$route.path != "/readiness/catalogs/roles") {
            await this.$router.push("/readiness/catalogs/roles");
          }
        } else if (tab == 1) {
          // Responsibilities tab (non-dashboard mode)
          if (
            !this.breadcrumItems.some((el) => el.text == "Responsibilities")
          ) {
            const existingItemIndex = this.breadcrumItems.findIndex(
              (el) => el.text == "Roles"
            );
            if (existingItemIndex > -1) {
              this.breadcrumItems.splice(existingItemIndex, 1);
            }
            this.breadcrumItems.push({
              text: "Responsibilities",
              disabled: true,
              href: "/readiness/catalogs/responsibilities",
            });
          }

          // Always push router change
          if (this.$route.path != "/readiness/catalogs/responsibilities") {
            await this.$router.push("/readiness/catalogs/responsibilities");
          }
        }
      }
    },
    async handleSort(data) {
      let ordering;
      if (data && data.field === "data") {
        ordering = data.descending ? "-name" : "name";
      }
      if (ordering) {
        this.currentOrdering = ordering;
        if (this.$route?.params?.type === "responsibilities") {
          this.$store.dispatch(
            "readinessCatalogsStore/setResponsibilitiesOrdering",
            ordering
          );
        } else {
          this.$store.dispatch("readinessCatalogsStore/setOrdering", ordering);
        }
      }
      try {
        this.$loader.show();
        const limit = 10;
        const page = this.currentPaginationModel.page || 1;
        const offset = (page - 1) * limit;

        await this.loadDataSourceForReadinessCatalogs({
          limit,
          offset,
          search: this.searchItems?.name,
          filters: this.appliedFiltersFromAPI || [],
          page,
          ordering:
            this.$route?.params?.type === "responsibilities"
              ? this.$store.state.readinessCatalogsStore
                  .responsibilitiesOrdering
              : this.$store.state.readinessCatalogsStore.ordering,
        });
      } catch (error) {
        console.error("Sort error:", error);
      } finally {
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }
    },
    async onRequestPagination(paginationData) {
      if (
        this.$route?.params?.type === "responsibilities" ||
        this.$route?.params?.type === "roles"
      ) {
        try {
          this.$loader.show();

          // Calculate offset based on page number
          const limit = 10;
          const offset = (paginationData.page - 1) * limit;

          // Call the store function with search parameters
          await this.loadDataSourceForReadinessCatalogs({
            limit: limit,
            offset: offset,
            search: this.searchItems?.name,
            filters: this.appliedFiltersFromAPI || [],
            page: paginationData.page,
            ordering:
              this.$route?.params?.type === "responsibilities"
                ? this.$store.state.readinessCatalogsStore
                    .responsibilitiesOrdering
                : this.$store.state.readinessCatalogsStore.ordering,
          });
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
        } catch (error) {
          console.error("Search error:", error);
        }
      } else {
        // Handle non-responsibilities pagination
        if (paginationData.page) {
          this.paginationModel.page = paginationData.page;
        }
      }
    },
    closeDialog() {
      this.actions.showAddRoleDialog = false;
      this.actions.showAddResponsibilityDialog = false;
      this.actions.activateRoleDialog = false;
      this.actions.deleteRoleDialog = false;
      this.actions.showRenameResponsibilityDialog = false;
      this.actions.deleteRoleDialog = false;
      this.actions.deleteResponsibilityDialog = false;
      this.actions.showActivateResponsiblityDialog = false;
      this.actions.showRetireResponsibilityDialog = false;
      this.actions.deActivateRoleDialog = false;
      this.actions.reActivateRoleDialog = false;
      this.actions.showDeActivateResponsiblityDialog = false;
      this.actions.showReActivateResponsiblityDialog = false;
      this.actions.showDetachDialog = false;
      this.actions.showAttachRoleDialog = false;
      this.actions.showArchiveDialog = false;
      this.archiveAction = null;
      this.openDefault = false;
    },
    handleReadinessOperations(operation) {
      if (operation.data.data.type == "role") {
        this.currentObj = operation.data.data.type;
        this.currentRole = JSON.parse(JSON.stringify(operation.data));
        this.roleHasDraftResponsibility =
          operation.data?.info?.draft_responsibilities_count;
      }
      if (operation.data.data.type == "responsibility") {
        this.currentObj = operation.data.data.type;
        this.currentResponsibility = JSON.parse(JSON.stringify(operation.data));
      }
      switch (operation.item.value) {
        case "activate_role":
          this.actions.activateRoleDialog = true;
          break;
        case "attach_responsibility_role":
          this.actions.attachedRoleDialog = true;
          this.currentRoleId = this.currentRole.id;
          this.getListOfResponsibilities(this.currentRole.id);
          this.openDefault = true;
          break;
        case "retired_role":
          this.actions.retiredRoleDialog = true;
          break;
        case "delete_role":
          this.actions.deleteRoleDialog = true;
          break;
        case "rename_role":
          this.actions.showRenameRoleDialog = true;
          break;
        case "rename_responsibility":
          this.actions.showRenameResponsibilityDialog = true;
          break;
        case "delete_responsibility":
          this.actions.deleteResponsibilityDialog = true;
          break;
        case "activate_responsibility":
          this.actions.showActivateResponsiblityDialog = true;
          break;
        case "retire_responsibility":
          this.actions.showRetireResponsibilityDialog = true;
          break;
        case "de_activate_role":
          this.actions.deActivateRoleDialog = true;
          break;
        case "re_activate_role":
          this.actions.reActivateRoleDialog = true;
          break;
        case "de_activate_responsibility":
          this.actions.showDeActivateResponsiblityDialog = true;
          break;
        case "re_activate_responsibility":
          this.actions.showReActivateResponsiblityDialog = true;
          break;
        case "detach_responsibility":
          this.actions.showDetachDialog = true;
          break;
        case "attach_role":
          this.currentResponsibilityId = this.currentResponsibility.realId;
          this.getListOfRoles(this.currentResponsibility.realId);
          this.actions.showAttachRoleDialog = true;
          break;
        case "archive_action":
          this.archiveAction = "archive";
          this.actions.showArchiveDialog = true;
          break;
        case "unarchive_action":
          this.archiveAction = "unarchive";
          this.actions.showArchiveDialog = true;
          break;
        default:
          break;
      }
    },
    handleItemSelected(data) {
      if (data && Object.prototype.hasOwnProperty.call(data, "id")) {
        this.attachmentId = data.id;
      }
    },
    async onArchiveCatalogs() {
      if (this.currentObj === "role") {
        if (this.archiveAction === "archive") {
          await this.archiveRole();
        } else if (this.archiveAction === "unarchive") {
          await this.unarchiveRole();
        }
      } else {
        if (this.archiveAction === "archive") {
          await this.archiveResponsibility();
        } else if (this.archiveAction === "unarchive") {
          await this.unarchiveResponsibility();
        }
      }
    },
    async attachRoleToResponsibility() {
      this.isAssigningObject = true;
      this.$loader.setAppLoading(true);
      try {
        await this.attachedRole();
        this.$notifications.success("Responsibility attached successfully.");
      } catch (e) {
        console.log("e: ", e);
      }
      this.isAssigningObject = false;
      this.$loader.setAppLoading(false);
    },
    async attachResponsibilityToRole() {
      this.isAssigningObject = true;
      this.$loader.setAppLoading(true);
      try {
        await this.attachedResponsibilityToRole();
        this.$notifications.success("Role attached successfully.");
      } catch (e) {
        console.log("e: ", e);
      }
      this.isAssigningObject = false;
      this.$loader.setAppLoading(false);
    },
    async addHandleItemSelected(item) {
      try {
        this.$loader.show();
        const payload = {
          name: item.name,
          accountId: this.accountId,
        };
        const newResponsibility = await this.$store.dispatch(
          "readinessCatalogsStore/createResponsibility",
          payload
        );
        this.attachmentId = newResponsibility.data.id;
        await this.attachedRole();
        this.actions.attachedRoleDialog = false;
      } catch (e) {
        console.error(e);
      } finally {
        this.$loader.hide();
      }
    },
    async addNewRole(item) {
      try {
        this.$loader.show();
        const payload = {
          name: item.name,
          account: this.accountId,
        };
        const newRole = await this.$store.dispatch(
          "readinessCatalogsStore/createRole",
          { role: payload, accountId: this.accountId }
        );
        this.attachmentId = newRole.id;
        await this.attachedResponsibilityToRole();
        this.actions.attachedRoleDialog = false;
      } catch (e) {
        console.error(e);
      } finally {
        this.$loader.hide();
      }
    },
    clearResponsibilityError() {
      this.responsibilityErrorMessage = "";
    },
    clearRoleError() {
      this.roleErrorMessage = "";
    },
  },
  computed: {
    ...mapState("readinessCatalogsStore", {
      storeRoles: (state) => state.roles,
      storeResponsibilities: (state) => state.responsibilities,
    }),
    showAttachResponsibilitiesPicker() {
      return this.$store.getters["featureFlags/ideaMDP389"];
    },
    menuItemsProp() {
      if (this.isDashboardFeatureEnabled) {
        return [
          {
            title: "Dashboard",
          },
          {
            title: "Roles",
            count: this.sidebarCountStore.getRolesCount,
          },
          {
            title: "Responsibilities",
            count: this.sidebarCountStore.getResponsibilitiesCount,
          },
          // { title: "Knowledge", count: 0 }, hide for now
        ];
      } else {
        return [
          {
            title: "Roles",
            count: this.sidebarCountStore.getRolesCount,
          },
          {
            title: "Responsibilities",
            count: this.sidebarCountStore.getResponsibilitiesCount,
          },
          // { title: "Knowledge", count: 0 }, hide for now
        ];
      }
    },
    getParentName() {
      if (this.currentResponsibility) {
        const {
          parentId,
          data: { attached_roles },
        } = this.currentResponsibility;
        const matchingRole = attached_roles.find(
          (role) => role.id === parentId
        );
        return matchingRole ? matchingRole.name : null;
      } else {
        return "";
      }
    },
  },
};
</script>
